var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3788 29.514H8.75C8.2922 29.5389 7.85294 29.7031 7.49104 29.9846C7.12914 30.2661 6.86186 30.6514 6.725 31.089L2.225 44.589C2 44.814 2 45.039 2 45.264C2 46.614 2.9 47.514 4.25 47.514H44.75C46.1 47.514 47 46.614 47 45.264C47 45.039 47 44.814 46.775 44.589L42.275 31.089C42.1381 30.6514 41.8709 30.2661 41.509 29.9846C41.1471 29.7031 40.7078 29.5389 40.25 29.514H31.6212M38 16.014C38 26.139 24.5 36.264 24.5 36.264C24.5 36.264 11 26.139 11 16.014C11 12.4336 12.4223 8.99978 14.9541 6.46804C17.4858 3.93629 20.9196 2.51398 24.5 2.51398C28.0804 2.51398 31.5142 3.93629 34.0459 6.46804C36.5777 8.99978 38 12.4336 38 16.014ZM29 16.014C29 18.4993 26.9853 20.514 24.5 20.514C22.0147 20.514 20 18.4993 20 16.014C20 13.5287 22.0147 11.514 24.5 11.514C26.9853 11.514 29 13.5287 29 16.014Z",
    stroke: "#08387C",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.beb8c938ed94e20830045514f82adc91.svg";
export { ForwardRef as ReactComponent };